module.exports = __webpack_public_path__ + "img/unit_BordeauxMetallic.12a0b731.png";